import type { CanDeactivateFn } from '@angular/router';
import { isObservable } from 'rxjs';
import { take } from 'rxjs/operators';
import { type AbstractRoute } from '../router/abstract-route-component';

export const canDeactivateGuard: CanDeactivateFn<AbstractRoute> = (
  component,
) => {
  if (!component.canDeactivate) {
    return true;
  }

  const result$ = component.canDeactivate();

  if (typeof result$ === 'boolean') {
    return result$;
  }

  if (isObservable(result$)) {
    return result$.pipe(take(1));
  }

  throw new Error(
    "Invalid response type given from 'canDeactivate()'. Type has to resolve to boolean.",
  );
};
